var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.8,12.1v1.4c-0.2,0-0.4-0.2-0.4-0.4v-0.6C1.4,12.3,1.6,12,1.8,12.1z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.6,13.6H3v-0.5c0-0.7-0.6-1.4-1.4-1.4l0,0C1.6,11.7,1.6,13.6,1.6,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6,13.6H3v-0.5c0-0.7-0.6-1.4-1.4-1.4l0,0C1.6,11.7,1.6,13.6,1.6,13.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.6,17.3c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7S17.6,15.8,17.6,17.3z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,17.3c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5C19.4,15.8,18.8,16.5,18.8,17.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.8,16.5c0,0.3,0.5,0.5,0.5,0.5s0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5C20.1,16,19.8,16.2,19.8,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.8,18c0-0.3,0.5-0.4,0.5-0.4s0.4,0.2,0.4,0.5c0,0.3-0.2,0.4-0.5,0.4C20,18.4,19.8,18.2,19.8,18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.5,16.8c0.3,0,0.4,0.5,0.4,0.5s-0.2,0.4-0.5,0.4c-0.3,0-0.4-0.2-0.4-0.5C19,17,19.3,16.7,19.5,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21,16.8c-0.3,0-0.4,0.5-0.4,0.5s0.2,0.4,0.5,0.4c0.3,0,0.4-0.2,0.4-0.5C21.5,17,21.3,16.7,21,16.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3,17.2l0-1.6c2.5-2.5,0.5-5.2-0.1-6.6c-0.2-0.4-0.7-0.1-0.5,0.3c0.6,1.4,2,3.8-0.3,5.9l-1.9,1.5 C8,16.8,8.5,16.5,8.5,17c0,0.2,6.4,0.2,6.4,0.2H16.3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7,17v0.4v0.2H9.2c-0.5,0-0.9-0.3-1-0.8l-0.5-2.1c0,0-3.4-0.4-4.7,0.4c-1.3,0.8-1.6,1.3-1.6,1.3 s0.5-3.5,2.6-4.5h7c0,0-1.5,1.2-1.8,2.3c-0.2,1.1,0.9,2,0.9,2h5.2L14.7,17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4,13.4l-2,0.3l0.1-1.2c0-0.7,0.6-1.2,1.2-1.2c0,0,0.9-0.1,0.8-0.1c0,0,0.1,0,0.1,0.1 c-0.4,0.6-0.6,1.3-0.4,2l0,0C19.4,13.3,19.4,13.4,19.4,13.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.9,12.2c0,0.8-0.4,1.4-0.6,1l0,0c-0.4-0.6-0.2-2.2,0.2-2.1C19.8,11.2,19.9,11.9,19.9,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.5,13.3c0,0-0.1,0-0.2-0.1l0,0c-0.3-0.5-0.3-1.6,0-2C19.9,11.3,20,12.9,19.5,13.3z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,7l-0.7,2.2h-0.4c-0.5,0-0.9-0.4-0.9-0.9V7.8c0,0,0.5-1,0.7-1C15.9,6.8,16.9,7,16.9,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "15.7,7.4 15.9,7.3 15,5.2 14,5.2 14,5.3 14.8,5.3  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13.5,6.4L13.5,6.4c0.3,0,0.6-0.2,0.6-0.5l0.1-0.7l-0.2-0.7C14,4.2,13.8,4,13.5,4l0,0L13.5,6.4L13.5,6.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,10.8c0,0-0.3-0.3-0.7-0.1c-0.4,0.2-1.5,3.1-1.6,3.7c-0.1,0.7,1.2,0.9,1.2,0.9l1.5-1.7L16.7,10.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.7,14.8c0.3-0.9,1.2-3.3,1.6-3.5c0.3-0.1,0.6,0,0.6,0.1l-0.1-0.6c0,0-0.3-0.3-0.7-0.1c-0.4,0.2-1.5,3.1-1.6,3.7 C14.4,14.5,14.5,14.7,14.7,14.8z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23,15c-0.8,0.6-2.1,0.2-2.6,0.2c-1.5,0-2.1,2-2.3,2c-0.1,0-2.1,0-2.1,0s-0.3-0.4,0.3-2 c0.2-0.6,0.4-1.1,0.9-1.5c1.2-0.9,3.4-1.1,4.4-0.4C22.2,13.7,22.7,14.4,23,15z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.3,15.6c0.2-0.7,0.4-1.3,0.9-1.8c0.6-0.5,1.4-0.8,2.2-0.9c-1.1-0.1-2.3,0.1-3.2,0.8c-0.5,0.4-0.7,0.9-0.9,1.5 c-0.6,1.6-0.3,2-0.3,2s0.5,0,1,0C16.9,16.9,17.1,16.3,17.3,15.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.4,17.3C2.4,18.8,3.6,20,5,20s2.7-1.2,2.7-2.7S6.5,14.6,5,14.6S2.4,15.8,2.4,17.3z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,17.3c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S5.8,15.8,5,15.8C4.2,15.8,3.5,16.5,3.5,17.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.6,16.5C4.6,16.7,5,17,5,17s0.5-0.2,0.5-0.5C5.5,16.2,5.3,16,5,16S4.6,16.2,4.6,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.5,18c0-0.3,0.5-0.4,0.5-0.4s0.4,0.2,0.4,0.5c0,0.3-0.2,0.4-0.5,0.4C4.7,18.4,4.5,18.2,4.5,18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.3,16.8c0.3,0,0.4,0.5,0.4,0.5s-0.2,0.4-0.5,0.4s-0.4-0.2-0.4-0.5C3.8,17,4,16.7,4.3,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.7,16.8c-0.3,0-0.4,0.5-0.4,0.5s0.2,0.4,0.5,0.4c0.3,0,0.4-0.2,0.4-0.5C6.2,17,6,16.7,5.7,16.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16.6H1c0,0-0.2-2.8,1.4-3.1c1.2-0.3,3.9-0.1,5.1,0c0.4,0,0.7,0.3,0.8,0.7L9,16.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6.4,14.2c0.4,0,0.7,0.3,0.8,0.7l0.4,1.7H9l-0.6-2.5c-0.1-0.4-0.4-0.7-0.8-0.7c-1.2-0.1-3.9-0.2-5.1,0 c-0.5,0.1-0.8,0.4-1,0.8C2.7,14.1,5.2,14.2,6.4,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13.5,8.3h2.3V7.5h-2.3c-0.2,0-0.4,0.2-0.4,0.4l0,0C13.1,8.1,13.3,8.3,13.5,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.2,8.4v0.8h-0.4c0-0.7,0-0.9,0-1.8L16.2,8.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.2,11.9H5.3l0,0c0-0.7,0.5-1.2,1.2-1.2H10C10.6,10.6,11.2,11.2,11.2,11.9L11.2,11.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.af34fb6a18c1520e70cacc6190c2cbd6.svg";
export { ForwardRef as ReactComponent };